import React, { useState, useEffect } from 'react';
import { Alert, Form } from 'react-bootstrap';
import { HHIEButton } from './utility/HHIEButton';
import { HHIECard } from './utility/HHIECard';
import { HHIEError } from './utility/HHIEError';
import { returnPOCUserObject } from './utility/returnPOCUserObject';

export function VerifyEmail() {
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState();
    const [clicked, setClicked] = useState(false);

    useEffect(() => {
        if (error || success) {
            setClicked(false);
        }
    }, [error, success]);

    const handleError = (message) => {
        setError(true);
        setErrorMessage(message);
        setSuccess(false);
        setSuccessMessage(null);
        setClicked(false);
    }
    const handleSubmit = async () => {
        setClicked(true);
        if (username === null || username.length < 4
            || password === null || password.length < 6) {
            handleError("Username and Password are not valid");
            return;
        }
        const POCUserData = {
            username: username, 
            password: password
        };
        const requestOptions = {
            method: "POST",
            body: JSON.stringify(POCUserData),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }

        const user = await fetch('api/login/TempPOC', requestOptions)
            .then(async (response) => {
                if (response.status === 204) {
                    return null;
                }
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message;
                    });
                }
                catch (ex) {
                    console.log(ex);
                    return null;
                }
            })
            .catch((error) => {
                handleError(error);
                console.log(error);
                return null;
            });
        // user has already updated their password, they shouldn't be needing to 'verify email', do we redirect to login, or do we check MID to see if they have completed registering?
        if (user !== null) {
            setSuccess(true);
            const pocUser = returnPOCUserObject(user);
            if (user.passwordIsTemporary) {
                sessionStorage.setItem("temporaryVerification", user.password);
            }
            sessionStorage.setItem("user", JSON.stringify(pocUser));
            // security questions complete and password is not temporary
            if (user.securityQuestionsComplete && !user.passwordIsTemporary) {
                setSuccessMessage("You've completed this portion of registration, please login.")
                setTimeout(() => {window.location.href = "/login";},3000);
                return;
            }
            // security questions have been complete, but password is still temporary
            if (user.passwordIsTemporary && user.securityQuestionsComplete) {
                setSuccessMessage("You've completed answering your security questions, please reset your temporary password.")
                setTimeout(() => {window.location.href = "/reset-temp-password";},3000);
                return;
            }
            // go and finish questions
            setSuccessMessage("Success! Please set your security questions.")
            setTimeout(() => {
                window.location.href = "/set-security-questions";
            },3000);
            return;
        }
        else {
            handleError("Your credentials are invalid. Please try again, or contact the HHIE Staff.");
        }
    }
    return (
        <HHIECard>
            {success &&
            <Alert variant="success">{successMessage}</Alert>
            }
            {!success && 
            <Form>
                <Form.Label>
                    Please enter the email address and temporary password 
                    you received via email from the HHIE to register.
                </Form.Label>
                <Form.Group
                    className="mb-3"
                    controlId="formBasicEmail"
                >
                    <Form.Control
                        required
                        type="email"
                        placeholder="Enter username or email" 
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    controlId="formBasicPassword"
                >
                    <Form.Control
                        required
                        type="password"
                        placeholder="Enter password" 
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Form.Group>
                {error && 
                <HHIEError message={errorMessage} onClick={() => {setError(false)}} />
                }
                {/* CLICKED, show loading alert */
                    !error && !success && clicked && <Alert variant="warning">Validating Credentials. . .</Alert>
                }
                <Form.Group>
                    <HHIEButton
                        id="verify-btn"
                        title="Verify"
                        disabled={!(username && password)}
                        onClick={handleSubmit}
                    />
                </Form.Group>
            </Form>}
        </HHIECard>
    );
}
